// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"56":"b21c0ae3","71":"cbae980e","179":"f50eed56","461":"063f31fa","517":"bb83a21f","667":"0ffc0760","796":"2b1d3838","875":"b8ae74ee","972":"b9dbb425"}[chunkId] + ".css";
};